var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSlackLogo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 23,
    height: 20,
    viewBox: "0 0 23 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "a",
    d: "M0 .037h10.47V8.94H0z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "c",
    d: "M0 .036h4.779V18.7H0z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(.128 10.571)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "b",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#a"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#C0205E",
    d: "M4.654 2.016c0 1.094-1.042 1.98-2.327 1.98S0 3.11 0 2.016C0 .923 1.042.036 2.327.036h2.327v1.98M5.817 2.016c0-1.093 1.042-1.98 2.327-1.98s2.326.887 2.326 1.98v4.95c0 1.093-1.041 1.98-2.326 1.98-1.285 0-2.327-.887-2.327-1.98v-4.95",
    mask: "url(#b)"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#48ABD1",
    d: "M8.252 4.066c-1.32 0-2.39-.91-2.39-2.033C5.862.91 6.932 0 8.252 0s2.39.91 2.39 2.033v2.033h-2.39M8.305 4.88c1.29 0 2.336.91 2.336 2.032 0 1.123-1.046 2.033-2.336 2.033H2.464c-1.29 0-2.336-.91-2.336-2.033 0-1.123 1.046-2.033 2.336-2.033h5.84"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#08A66C",
    d: "M17.332 6.912c0-1.123 1.07-2.033 2.389-2.033 1.32 0 2.39.91 2.39 2.033 0 1.123-1.07 2.033-2.39 2.033h-2.39V6.912"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(11.597)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "d",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#c"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#08A66C",
    d: "M4.779 6.914c0 1.085-1.07 1.965-2.39 1.965S0 7.999 0 6.914V2C0 .916 1.07.036 2.39.036s2.389.88 2.389 1.965v4.913",
    mask: "url(#d)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#E8AA30",
    d: "M2.39 14.773c1.32 0 2.389.88 2.389 1.965 0 1.086-1.07 1.965-2.39 1.965S0 17.823 0 16.738v-1.965h2.39",
    mask: "url(#d)"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#E8AA30",
    d: "M13.933 14.637c-1.29 0-2.336-.91-2.336-2.033 0-1.122 1.046-2.033 2.336-2.033h5.841c1.29 0 2.336.91 2.336 2.033 0 1.123-1.046 2.033-2.336 2.033h-5.84"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSlackLogo);
export default __webpack_public_path__ + "static/media/slack-logo.6d5d587c.svg";
export { ForwardRef as ReactComponent };